import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "projects/tilmanagement/src/environments/environment";
import {
  BulkEditTechnicalLetter,
  LookUpData,
} from "../../interfaces/technical-letters/bulk-edit-technical-letter.models";
const apiHost = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class BulkEditTechnicalLettersService {
  newBulkEditTechnicalLetter: BulkEditTechnicalLetter;

  constructor(private httpClient: HttpClient) {}
  public setBulkEditTechnicalLetter(data: BulkEditTechnicalLetter) {
    this.newBulkEditTechnicalLetter = {
      ...this.newBulkEditTechnicalLetter,
      ...data,
    };
  }

  public getBulkEditTechnicalLettersDataAsync() {
    return this.httpClient.get<BulkEditTechnicalLetter[]>(
      `${apiHost}/technical-letters/bulk-edit`
    );
  }

  public updateBulkEditTechnicalLetter(
    bulkEditTechnicalLetter: BulkEditTechnicalLetter
  ) {
    return this.httpClient.put(
      `${apiHost}/technical-letters/bulk-edit/update`,
      bulkEditTechnicalLetter
    );
  }

  public deleteBulkEditTechnicalLetter(bulkEditTechnicalLetterId: number) {
    return this.httpClient.delete(
      `${apiHost}/technical-letters/bulk-edit/delete/${bulkEditTechnicalLetterId}`
    );
  }

  getLookUpData() {
    return this.httpClient.get<LookUpData[]>(
      `${apiHost}/technical-letters/bulk-edit/lookups`
    );
  }
}
